import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '级别',
      prop: 'level'
    },
      {
          label: '积分',
          prop: 'score'
      },
      {
          label: '会员类型',
          prop: 'memberLevel'
      }
  ]
}
